export function useValidateRequiredFields(dataModel, validationViewModel, requiredFields) {

    let result = true;

    requiredFields.forEach(item => {
        // Look at the required validated fields object, if any values are set true, this is a chosen required field
        // check the model data and validate for the required controls. Other Validation can be checked and a different
        // message triggered if you pass the validation-text v-model to the control, then choose the message number required

        if (item.validate) {

            //TODO Make sure we only work with flat data and not ddl {id, text} objects to check for validation

            // if (typeof (dataModel[item.modelName]) === 'object' && dataModel.hasOwnProperty(item.modelName.toString())) {
            //
            //     if (!dataModel[item.modelName].value) {
            //         validationViewModel[item.modelName].value = true;
            //         validationViewModel[item.modelName].messageNumber = 0;
            //         result = false;
            //     } else {
            //         validationViewModel[item.modelName].value = false;
            //     }
            //
            // } else {
            //
            if (dataModel.hasOwnProperty(item.modelName.toString())) {

                if (!dataModel[item.modelName]) {
                    validationViewModel[item.modelName].value = true;
                    validationViewModel[item.modelName].messageNumber = 0;
                    result = false;
                } else {
                    validationViewModel[item.modelName].value = false;
                }

            }

        }

    })

    return result;
}
